import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { IoCloseOutline } from 'react-icons/io5';
import { sendMail } from '../api/api';
import { EmailValidator } from '../validators/BookingValidator';

export default function SendMailModal({ isOpen = false, onClose = undefined }) {
  const [email, setEmail] = useState('');

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await EmailValidator.validate({ email });
      const bookingId = sessionStorage.getItem('bookingId');
      if (bookingId && email) {
        const { error, data } = await sendMail(bookingId, email);
        if (!error && data?.status == 'Success') {
          toast.success(t('mailSendSuccessfully'));
          handleOnClose();
        } else {
          toast.error(t('somethingWentWrong'));
        }
      }
    } catch (e) {
      toast.error(t(e?.message));
    }
  };

  const handleOnClose = () => {
    onClose();
  };

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'unset';
  }, [isOpen]);

  return (
    <>
      {isOpen && (
        <div
          className="w-full h-full px-4 bg-black/50 fixed inset-0 flex items-start justify-center"
          onClick={handleOnClose}>
          <div
            className="bg-white rounded-2xl shadow-md py-4 px-6 w-full max-w-md mt-32"
            onClick={(e) => e.stopPropagation()}>
            <div className="flex space-x-2 items-center">
              <h2 className="text-primary-300 leading-5 sm:leading-normal font-medium text-lg flex-grow">
                {t('enterEmailWantToSend')}
              </h2>
              <button
                className="flex-shrink-0 mr-10 bg-black/5 rounded-full text-gray-500 hover:bg-black/10 z-[501]"
                onClick={handleOnClose}>
                <IoCloseOutline size={24} />
              </button>
            </div>
            <input
              onChange={handleChange}
              type="text"
              placeholder={t('email')}
              className="outline-none border-gray-200 border px-4 text-xs w-full h-10 rounded-full bg-white mt-3"
            />
            <button
              className="bg-gradient-to-r from-blue-700 via-violet-600 to-purple-500 text-xs px-6 py-3 rounded-full text-white tracking-wide w-full hover:opacity-90 mt-4 mb-2"
              type="button"
              onClick={handleSubmit}>
              {t('send')}
            </button>
          </div>
        </div>
      )}
    </>
  );
}
